export default __webpack_public_path__ + "static/blob13-198401be72d791cac563410a462fdb71.svg";